<template>
  <el-dialog
    class="put_detail"
    append-to-body
    center
    title="投放详情"
    :visible.sync="visible"
    width="790px"
    :close-on-click-modal="false"
    @opened="dialogOpen">
    <div class="header_title" slot="title">投放详情</div>
    <div class="little_tip">
      <el-select
        class="date_sel"
        size="small"
        v-model="selDate"
        @change="changePlayDate"
        popper-class="no_border">
        <el-option
          v-for="{ label, value } in playDates"
          :key="value"
          :label="label"
          :value="value">
        </el-option>
      </el-select>
      <el-select
        class="type_sel"
        size="small"
        v-model="screenType"
        popper-class="no_border">
        <el-option v-for="({ type, value }) in allTypes" :key="value" :value="value" :label="type"></el-option>
      </el-select>
      <el-input
        class="search_input"
        v-model="searchTxt"
        clearable
        placeholder="查找小区"
        size="small">
        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
      </el-input>
    </div>

    <div class="residence_box">
      <!-- 处理本来就无数据的情况 -->
      <div v-if="isNoData" class="data_none">
        <img class="tip_img" src="../../assets/submit_fail.png" alt="温馨提示">
        <div class="tip_txt">{{tipNone}}</div>
      </div>
      <div v-else>
        <div class="no_nbhd" v-if="searchTxt && isEmpty(toShowList)">暂无结果，换个名称重新试试吧～</div>
        <!-- 小区list -->
        <PutDetailNbhd
          v-for="nbhd in toShowList"
          :key="nbhd.nbhdName + nbhd.nbhdGuid + screenType"
          :nbhdData="nbhd"
          :buildParam="orderInfo"
          :chooseDate="selDate"
          :screenType="screenType"
          :normalPlayCount="normalCount">
        </PutDetailNbhd>
      </div>
    </div>

    <div class="footer" slot="footer">
      <button class="close_button" @click="$emit('update:show', false)">确定</button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import PutDetailNbhd from './PutDetailNbhd'
import { getOrderPlayInfo } from '@/utils/api'

export default {
  name: 'PutDetail',
  components: { PutDetailNbhd },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      nbhdList: [],
      nbhdListTw: [],
      tipNone: '',
      searchTxt: '',
      normalCount: 0,
      selDate: '',
      allTypes: [{ value: '0', type: '梯内屏' }, { value: '1', type: '梯外屏' }],
      screenType: '0'
    }
  },
  computed: {
    visible: {
      get () { return this.show },
      set (v) { this.$emit('update:show', v) }
    },
    playDates () {
      let temp = []
      if (!this.isEmpty(this.orderInfo.dateList)) {
        this.orderInfo.dateList.forEach(el => {
          let obj = {}
          obj.value = el
          obj.label = el
          temp.push(obj)
        })
      } else {
        let st = this.orderInfo.startDate
        if (st) temp.push({ value: st, label: st })
      }
      return temp
    },
    isNoData () {
      if (this.screenType === '0') {
        return !this.loading && this.isEmpty(this.nbhdList)
      } else {
        return !this.loading && this.isEmpty(this.nbhdListTw)
      }
    },
    toShowList () {
      let theList = this.screenType === '0' ? this.nbhdList : this.nbhdListTw
      if (!this.searchTxt) {
        return theList
      }
      return theList.filter(item => item.nbhdName.indexOf(this.searchTxt) > -1)
    }
  },
  watch: {
    searchTxt (val, old) {
      val = val.replace(/\s*/g, '')
      this.searchTxt = val
    },
    orderInfo (v) {
      this.selDate = v.startDate || ''
    },
    visible (v) {
      if (v) {
        this.searchTxt = ''
      }
    }
  },
  methods: {
    dialogOpen () {
      this.tipNone = '暂无数据'
      this.screenType = '0'
      this.nbhdList = []
      this.nbhdListTw = []
      this.getPlayInfoDetail(true)
    },
    handleSearch () {
    },
    async changePlayDate (selDate) {
      // 切换日期需清空梯内、梯外屏小区数据
      this.nbhdList = []
      this.nbhdListTw = []
      this.getPlayInfoDetail()
    },
    async getPlayInfoDetail (first) {
      let params = { 'orderGuid': this.orderInfo.guid, 'targetDate': this.selDate }
      this.loading = true
      let res = await getOrderPlayInfo(params)
      this.loading = false
      if (0 === res.code) {
        if (res.data) {
          let { nbhdInfoList = [], twNbhdInfoList = [], normalPlayCount = 0 } = res.data
          this.nbhdList = nbhdInfoList || []
          this.nbhdListTw = twNbhdInfoList || []
          if (first) {
            this.normalCount = normalPlayCount
          }
        }
      } else if (res.code === 900501) {
        this.tipNone = res.msg
        this.messageTip(res.msg)
      }
    }
  }
}
</script>

<style lang="scss">
.el-dialog__wrapper.put_detail {
  .el-dialog--center {
    border-radius: 8px;
    .el-dialog__header {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #E9E9E9;
      padding: 0;
    }
    .el-dialog__headerbtn {
      top: 17px;
      right: 18px;
      font-weight: 600;
      color: #282729;
    }
    .el-dialog__body {
      background: #f5f5f5;
      box-sizing: content-box;
      height: 530px;
      overflow: auto;
      padding: 20px;
    }
    .el-dialog__footer {
      height: 60px;
      padding: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep .el-select .el-input__suffix .el-icon-arrow-up {
  position: relative;
  right: 0;
}
.no_border {
  border: 0 !important;
}
.header_title {
  font-size: 18px;
  font-weight: 600;
}
.little_tip {
  position: relative;
  color: #999;
  height: 40px;
  line-height: 40px;
  .date_sel {
    width: 180px;
    margin-right: 10px;
  }
  .type_sel {
    width: 120px;
  }
  .search_input {
    width: 240px;
    height: 30px;
    float: right;
    ::v-deep .el-input__inner {
      border-radius: 15px;
    }
    ::v-deep .el-input-group__append {
      background: transparent;
      border: none;
      width: 30px;
      padding: 0;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      .el-button {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
      }
    }
  }
}
.residence_box {
  color: #666;
  position: relative;
  padding: 10px 0 20px;
  height: 490px;
  .data_none {
    color: #999;
    width: 100%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    .tip_img {
      width: 93px;
      height: 75px;
      margin-bottom: 20px;
    }
    .tip_txt {
      width: 628px;
      margin: 0 auto;
    }
  }
  ::v-deep .el-collapse.nbhd {
    background: #fff;
    border: none;
    margin-bottom: 10px;
    padding: 0 14px 0px 20px;
    .el-collapse-item__wrap {
      border-bottom: none;
    }
    .el-collapse-item__header {
      border-bottom: none;
    }
  }
  .no_nbhd {
    background: #fff;
    border-radius: 4px;
    color: #999;
    font-size: 14px;
    width: 100%;
    height: 62px;
    line-height: 62px;
    text-align: center;
  }
}
.footer {
  padding: 15px 0;
  border-top: 1px solid #E9E9E9;
  text-align: center;
  .close_button {
    width: 120px;
    height: 30px;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border-radius: 4px;
    border: none;
    cursor: pointer;
    color: #FFF;
    &:last-child {
      margin-left: 20px;
      background: #FFF;
      color: #282729;
      border: 1px solid #D4D4D4;
    }
  }
}
</style>
